export const componentList = (state) => state.componentList;

export const loadingComponents = (state) => state.loadingComponents;
